import { CRUDTable, TitledContainer } from 'components';

import { useGetCompanies, usePatchRequest, usePostRequest, useUserRole } from 'hooks';
import { pushItemInArrayWithState, replaceItemInArrayWithState } from 'utils';

import { DisplayCompany, RetailerCompanyCreate, RetailerCompanyUpdate } from 'codegen';
import { InitialTableActions } from 'types';

import { columns } from './lib';

export const Companies = () => {
  const [{ companies, loading }, setCompanies] = useGetCompanies();

  const [postCompanies, { loading: postLoading }] = usePostRequest<DisplayCompany, RetailerCompanyCreate>({
    url: '/companies',
    options: {
      onSuccess: ({ data }) => pushItemInArrayWithState(data, setCompanies),
    },
  });

  const [patchCompanies, { loading: patchLoading }] = usePatchRequest<DisplayCompany, RetailerCompanyUpdate>({
    options: {
      onSuccess: ({ data }) => replaceItemInArrayWithState(data, setCompanies),
    },
  });

  const { isAdmin } = useUserRole();

  return (
    <TitledContainer title='Companies'>
      <CRUDTable
        verticalScroll
        id='all-companies-table'
        columns={columns}
        dataSource={companies}
        loading={loading || postLoading || patchLoading}
        addNewBtn={{ visible: isAdmin, text: 'Add Company' }}
        onPostTableData={(data) => postCompanies({ payload: data })}
        onPatchTableData={({ id, ...rest }) => patchCompanies({ callbackURL: `/companies/${id}`, payload: rest })}
        initialTableActions={isAdmin ? [{ type: InitialTableActions.Edit }] : undefined}
      />
    </TitledContainer>
  );
};
